import { Component, OnInit } from '@angular/core';
import { DomainService } from 'src/app/core/domain/domain.service';
import { WindowRef } from 'src/app/core/domain/window-ref';
import { ProfileService } from 'src/app/core/translation/profile.service';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    standalone: true
})
export class PageNotFoundComponent implements OnInit {
  private translationIndex = 'pageNotFound';
  private commonIndex = 'common';
  message: any;
  homeUrl: string;

  constructor(private readonly pfs: ProfileService, private readonly windowRef: WindowRef, private readonly domain: DomainService) { }

  ngOnInit(): void {
    this.message = { ...this.pfs.messages[this.commonIndex], ...this.pfs.messages[this.translationIndex]};
    this.homeUrl = this.domain.getHomeUrl(this.windowRef.getHostname());
  }

}
